import { props } from '@ngrx/store';
import { createAction } from '@ngrx/store';
import { MemberCountResponse } from 'src/app/types/Member';


// This actions will called to create action and load the data in store

// command
export const loadMemberCounts=createAction(
    "[MemberCount Init] Load Member Count"
)

// effect action
export const memberCountLoaded = createAction(
    "[Load Member Count Effect] Member Count Loaded",
    props<{memberCount:MemberCountResponse}>()
);

